import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link
              to="/"
              className="flex items-center gap-2 text-lg font-heading font-bold text-foreground-900 mb-4 whitespace-nowrap"
            >
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xs">
                <i className="ri-hearts-line"></i>
              </span>
              白丝萝莉
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {siteInfo.tagline}
            </p>
            <p className="text-sm text-foreground-500 mt-2">
              探索洛丽塔时尚的无限魅力，分享精致甜美的生活方式。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">
              <a href="#categories-footer">热门分类</a>
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">
              <a href="#quick-links">快速链接</a>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/category/chuanda-zhinan"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                >
                  穿搭指南
                </Link>
              </li>
              <li>
                <Link
                  to="/category/pinpai-tuijian"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                >
                  品牌推荐
                </Link>
              </li>
              <li>
                <Link
                  to="/category/huodong-zixun"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                >
                  活动资讯
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">
              <a href="#contact-footer">联系我们</a>
            </h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-foreground-500"></i>
                </span>
                <a href={`mailto:${siteInfo.contact.email}`} className="hover:text-primary-500 transition-colors duration-200">
                  {siteInfo.contact.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-wechat-line text-foreground-500"></i>
                </span>
                {siteInfo.contact.wechat}
              </li>
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-weibo-line text-foreground-500"></i>
                </span>
                {siteInfo.contact.weibo}
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 白丝萝莉 - 探索洛丽塔时尚的无限魅力。保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}